import { render, staticRenderFns } from "./ArtistList.vue?vue&type=template&id=022913b0&scoped=true&lang=pug&"
import script from "./ArtistList.vue?vue&type=script&lang=js&"
export * from "./ArtistList.vue?vue&type=script&lang=js&"
import style0 from "./ArtistList.vue?vue&type=style&index=0&id=022913b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022913b0",
  null
  
)

export default component.exports